import React__default from 'react';
import { DmButton } from '../../../DmButton/DmButton.js';
import Error404 from '../../assets/svg/error404.js';
import Error500 from '../../assets/svg/error500.js';
import Error503 from '../../assets/svg/error503.js';
import Error403 from '../../assets/svg/error403.js';
import Triangle3 from '../../assets/svg/triangle3.js';
import Triangle4 from '../../assets/svg/triangle4.js';
import Triangle6 from '../../assets/svg/triangle6.js';
import Triangle7 from '../../assets/svg/triangle7.js';
import Logo from '../../assets/svg/logo.js';

function ErrorScreen(props) {
  var className = props.className,
    style = props.style,
    titleText = props.titleText,
    descriptionText = props.descriptionText,
    actionText = props.actionText,
    actionIcon = props.actionIcon,
    onClick = props.onClick,
    error = props.error;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(className, " error-screen-container"),
    style: {
      style: style
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React__default.createElement(Triangle4, null), /*#__PURE__*/React__default.createElement(Triangle7, {
    style: {
      margin: '9px 0 0 12px'
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "error-screen-info-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '500px'
    }
  }, /*#__PURE__*/React__default.createElement(Logo, null), /*#__PURE__*/React__default.createElement("div", {
    className: "error-screen-info-title-text"
  }, titleText), /*#__PURE__*/React__default.createElement("div", {
    className: "error-screen-info-description-text"
  }, descriptionText), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: '50px'
    }
  }, /*#__PURE__*/React__default.createElement(DmButton, {
    type: "text",
    style: {
      padding: 0
    },
    icon: actionIcon,
    label: actionText,
    onClick: onClick
  }))), /*#__PURE__*/React__default.createElement("div", null, error === '503' ? /*#__PURE__*/React__default.createElement(Error503, null) : error === '500' ? /*#__PURE__*/React__default.createElement(Error500, null) : error === '403' ? /*#__PURE__*/React__default.createElement(Error403, null) : /*#__PURE__*/React__default.createElement(Error404, null))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React__default.createElement(Triangle3, null), /*#__PURE__*/React__default.createElement(Triangle6, {
    style: {
      margin: '55px 0 0 12px'
    }
  })));
}

export { ErrorScreen as default };
